<template>
  <b-row>
    <b-col md="12">

      <!-- Alert: No item found -->
      <b-alert
        variant="danger"
        :show="errorMessage !== ''"
      >
        <h4 class="alert-heading">
          {{ errorMessage }}
        </h4>

      </b-alert>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class=""
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <b-row>

            <b-col md="12">

              <validation-provider
                #default="validationContext"
                :name="$t('Chọn phòng thu ')"
                rules="required"
              >
                <b-form-group label-for="series_id">
                  <template #label>
                    <label class="d-block font-weight-bolder">Chọn phòng thu <span class="text-danger">*</span></label>
                  </template>
                  <v-select
                    v-model="itemData.studio_id"
                    :options="dataStudio"
                    :reduce="(val) => val.id"
                    label="name"
                    placeholder="--Chọn--"
                  />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!--  Nội dung -->
            <b-col md="12">

              <validation-provider
                #default="validationContext"
                :name="$t('Nội dung')"
                rules="required"
              >
                <b-form-group
                  :label="$t('Nội dung')"
                  label-for="title"
                >
                  <template #label>
                    <label class="d-block font-weight-bolder">Nội dung <span class="text-danger">*</span></label>
                  </template>
                  <b-form-textarea
                    id="content"
                    v-model="itemData.content"
                    :state="getValidationState(validationContext)"
                    rows="3"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

            </b-col>
            <b-col md="12">

              <validation-provider
                #default="validationContext"
                :name="$t('Kiểu')"
                rules="required"
              >
                <b-form-group label-for="type">
                  <template #label>
                    <label class="d-block font-weight-bolder">Kiểu <span class="text-danger">*</span></label>
                  </template>
                  <v-select
                    v-model="itemData.type"
                    :options="typeOptions"
                    :reduce="val => val.id"
                    label="name"
                    placeholder="--Chọn--"
                  />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">

              <validation-provider
                #default="validationContext"
                vid="start_date"
                name="Thời gian bắt đầu"
                rules="required"
              >
                <b-form-group
                  label="Thời gian bắt đầu"
                  label-for="start_date"
                >
                  <template #label>
                    <label class="d-block font-weight-bolder pb-0">Thời gian bắt đầu<span class="text-danger">*</span></label>
                  </template>
                  <flat-pickr
                    v-model="itemData.start_date"
                    class="form-control"
                    :config="configDate"
                    placeholder="dd-mm-yyyy hh:i"
                    theme="dark"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">

              <validation-provider
                #default="validationContext"
                vid="start_date"
                name="Thời gian kết thúc"
                rules="required"
              >
                <b-form-group
                  label="Thời gian kết thúc"
                  label-for="start_date"
                >
                  <template #label>
                    <label class="d-block font-weight-bolder pb-0">Thời gian kết thúc<span class="text-danger">*</span></label>
                  </template>
                  <flat-pickr
                    v-model="itemData.end_date"
                    class="form-control"
                    :config="configDate"
                    placeholder="dd-mm-yyyy hh:i"
                    theme="dark"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="validationContext"
                :name="$t('Người tham gia')"
                rules="required"
              >
                <b-form-group label-for="manager_id">
                  <template #label>
                    <label class="d-block font-weight-bolder">Người tham gia <span class="text-danger">*</span></label>
                  </template>
                  <v-select
                    v-model="itemData.manager_ids"
                    :multiple="true"
                    :options="dataUser"
                    :reduce="val => val.id"
                    label="full_name"
                    placeholder="--Chọn--"
                  />
                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!--  Mô tả -->
            <b-col md="12">

              <b-form-group
                :label="$t('Mô tả')"
                label-for="title"
              >
                <template #label>
                  <label class="d-block font-weight-bolder">Mô tả</label>
                </template>
                <b-form-textarea
                  id="content"
                  v-model="itemData.description"
                  rows="3"
                />
              </b-form-group>

            </b-col>
            <b-col md="12">

              <div
                v-for="(item) in dataForms"
                :key="item.id"
              >
                <b-form-group v-if="item.type === 'number'">
                  <template #label>
                    <label class="d-block font-weight-bolder">{{ item.field }} </label>
                  </template>
                  <b-form-input
                    v-model="item.value"
                    type="number"
                    trim
                  />
                </b-form-group>
                <b-form-group v-if="item.type === 'text'">
                  <template #label>
                    <label class="d-block font-weight-bolder">{{ item.field }} </label>
                  </template>
                  <b-form-input
                    v-model="item.value"
                    type="text"
                    trim
                  />
                </b-form-group>
                <b-form-group v-if="item.type === 'date'">
                  <template #label>
                    <label class="d-block font-weight-bolder">{{ item.field }}</label>
                  </template>
                  <flat-pickr
                    v-model="item.value"
                    class="form-control"
                    :config="configDate"
                    placeholder="dd-mm-yyyy"
                  />
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              <span>{{ $t('Save') }}</span>
            </b-button>
          </div>

        </b-form>
      </validation-observer>

    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback, BFormCheckbox, BFormTextarea, BCardText, BFormSelect,
} from 'bootstrap-vue'
import {
  ref,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNumDot, max,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'
import moment from 'moment'

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BCardText,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    flatPickr,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      alphaNumDot,
      max,
      dataSeries: [],

    }
  },
  setup(props, { emit }) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const errorMessage = ref('')
    const dataStudio = ref([])
    const dataForms = ref([])
    const dataUser = ref([])
    const typeOptions = [
      { name: 'Không lặp', id: 1 },
      { name: 'Lặp hàng ngày', id: 2 },
    ];
    const defaultItemData = {
      content: '',
      studio_id: '',
      description: '',
      type: 1,
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)));

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)
    const formatDate = (value) => moment(String(value)).format('DD-MM-YYYY')

    const getAllStudioIsNormal = () => {
      store.dispatch('studio/fetchAllIsStatusNormal', { isPaginate: 0 })
        .then(response => {
          const result = response.data
          if (result.code === 200) {
            dataStudio.value = result.data;
          }
        })
        .catch(error => {
          // console.log('error', error)
        })
    }
    getAllStudioIsNormal()
    const onSubmit = () => {
      errorMessage.value = '';
      (itemData.value.data_fields = dataForms.value);
      store.dispatch('studio/createStudioBook', itemData.value)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.code === 200) {
              showToast(response.data.message, { variant: 'success' });
              resetForm()
              emit('updateData')
            } else {
              showToast(response.data.message)
              errorMessage.value = response.data.message;
            }
          }
        })
    }

    const getFormSetting = () => {
      store.dispatch('studio/getFormSetting')
        .then(response => {
          if (response.data.code === 200) {
            const rslt = response.data.data;
            if (rslt.length > 0) {
              dataForms.value = rslt;
            }
          }
        })
    }
    getFormSetting()
    const fetchManager = () => {
      store.dispatch('users/fetchUsers', {
        isPaginate: '0',
      })
        .then(response => {
          if (response.data.code === 200) {
            dataUser.value = response.data.data;
          }
        })
    }
    fetchManager();
    const today = new Date();
    const hour = today.getHours();
    const configDate = ref({
      dateFormat: 'd-m-Y H:i',
      enableTime: true,
      locale: Vietnamese, // locale for this instance only
      defaultHour: hour,
      time_24hr: true,
      theme: 'dark',
    });
    return {
      id,
      errorMessage,
      itemData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      configDate,
      dataStudio,
      dataForms,
      typeOptions,
      dataUser,
    }
  },

  methods: {
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
